import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import { LABOR } from "../_constants/actionConstants";
import raiseWarning from "./raiseWarning";
import raiseError from "./raiseError";

const deleteLabor = (laborId, projectId) => async (dispatch) => {
  dispatch({ type: LABOR.DELETE });
  const apiEndpoint = `${BASE_URL}/api/Labor/${laborId}`;
  try {
    const res = await axios.delete(apiEndpoint);
    if (res.data.message) {
      dispatch({ type: LABOR.DELETE_REJECTED });
      raiseWarning(LABOR.DELETE_REJECTED, res.data.message);
    } else {
      dispatch({ type: LABOR.DELETE_FULFILLED });
      dispatch({ type: LABOR.CLEAR_DETAILS, laborId, projectId });
    }
  } catch (err) {
    raiseError(LABOR.DELETE_REJECTED, err.response.data);
  }
};

const getDetails = (projectId, laborId) => async (dispatch) => {
  dispatch({ type: LABOR.FETCH_DETAILS });
  const apiEndpoint = `${BASE_URL}/api/Labor/${laborId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: LABOR.FETCH_DETAILS_FULFILLED,
      payload: res.data,
      projectId,
      laborId,
    });
  } catch (err) {
    raiseError(LABOR.FETCH_DETAILS_REJECTED, err.response.data);
  }
};

const downloadAll = (projId) => async (dispatch) => {
  dispatch({ type: LABOR.DOWNLOAD_ALL });
  const apiEndpoint = `${BASE_URL}/api/Project/${projId}/LaborsAsCsv`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: LABOR.DOWNLOAD_ALL_FULFILLED });
    const file = new Blob([res.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "labor.csv");
    document.body.appendChild(link);
    link.click();
    return;
  } catch (err) {
    raiseError(LABOR.DOWNLOAD_ALL_REJECTED, err.response.data);
  }
};

const getAll = (projectId) => async (dispatch) => {
  dispatch({ type: LABOR.FETCH_ALL_FOR_PROJECT });
  const apiEndpoint = `${BASE_URL}/api/Project/${projectId}/Labors`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: LABOR.FETCH_ALL_FOR_PROJECT_FULFILLED,
      projLaborList: res.data,
      projectId,
    });
    return res.data;
  } catch (err) {
    raiseError(LABOR.FETCH_ALL_FOR_PROJECT_REJECTED, err.response.data);
  }
};

/**
 * Same as getAll(), but only fetches new list if there is an existing list.
 * @param {Number} projectId
 * @returns
 */
const updateAll = (projectId) => async (dispatch, getState) => {
  const projLaborListExists = projectId in getState().labors.projLaborLists;
  if (!projLaborListExists) return;

  dispatch({ type: LABOR.FETCH_ALL_FOR_PROJECT });
  const apiEndpoint = `${BASE_URL}/api/Project/${projectId}/Labors`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({
      type: LABOR.FETCH_ALL_FOR_PROJECT_FULFILLED,
      projLaborList: res.data,
      projectId,
    });
    return res.data;
  } catch (err) {
    raiseError(LABOR.FETCH_ALL_FOR_PROJECT_REJECTED, err.response.data);
  }
};

const add = (newLaborData) => async (dispatch) => {
  dispatch({ type: LABOR.ADD });
  const apiEndpoint = `${BASE_URL}/api/Labor`;
  try {
    const res = await axios.post(apiEndpoint, newLaborData);
    if (res.data.message) {
      dispatch({ type: LABOR.ADD_REJECTED });
      raiseWarning(LABOR.ADD_REJECTED, res.data.message);
    } else {
      dispatch({ type: LABOR.ADD_FULFILLED });
      return res.data;
    }
  } catch (err) {
    raiseError(LABOR.ADD_REJECTED, err.response.data);
  }
};

const update = (laborDto) => async (dispatch) => {
  dispatch({ type: LABOR.EDIT });
  const apiEndpoint = `${BASE_URL}/api/Labor`;
  try {
    const res = await axios.put(apiEndpoint, laborDto);
    if (res.data.message) {
      dispatch({ type: LABOR.EDIT_REJECTED });
      raiseWarning(LABOR.EDIT_REJECTED, res.data.message);
    } else {
      dispatch({
        type: LABOR.EDIT_FULFILLED,
        laborDetails: res.data,
        laborId: laborDto.laborId,
        projectId: laborDto.projectId,
      });
    }
  } catch (err) {
    raiseError(LABOR.EDIT_REJECTED, err.response.data);
  }
};

const hasLinks = (laborId) => async (dispatch) => {
  dispatch({ type: LABOR.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/Labor/${laborId}/HasLinks`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: LABOR.GENERIC_REQUEST_FULFILLED });
    return res.data; // bool value
  } catch (err) {
    raiseError(LABOR.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const verify = (laborDto) => async (dispatch) => {
  dispatch({ type: LABOR.VERIFY });
  const apiEndpoint = `${BASE_URL}/api/Labor/Verify`;
  try {
    const res = await axios.put(apiEndpoint, laborDto);
    if (res.data.message) {
      dispatch({ type: LABOR.VERIFY_REJECTED });
      raiseWarning(LABOR.VERIFY_REJECTED, res.data.message);
    } else {
      dispatch({
        type: LABOR.VERIFY_FULFILLED,
        projectId: laborDto.projectId,
        projLaborList: res.data,
      });
    }
  } catch (err) {
    raiseError(LABOR.VERIFY_REJECTED, err.response.data);
  }
};

// Keep this interface alphabetical
const laborActions = {
  add,
  deleteLabor,
  downloadAll,
  getAll,
  getDetails,
  hasLinks,
  update,
  updateAll,
  verify,
};

export default laborActions;
